import type { ReworkCategory } from '@scans/types';

export const categoryTitles: Record<ReworkCategory, string> = {
  ADDRESS: 'Address',
  CONNECTOR_OR_PIPE_FITTING: 'Connector/pipe fitting',
  DOUBLE_CHECK_PHOTOS: 'Doublecheck photos',
  ELEMENT_NAME: 'Spline',
  MISSING_ELEMENT: 'Missing element',
  PIPE_COLOUR: 'Pipe colour',
  PIPE_STRENGTH: 'Pipe strength',
  PROTECTIVE_PIPE: 'Protective pipe',
  SCAN_POSITION: 'Scan',
  TRENCH_OR_ELEMENT_PLACEMENT: 'Trench',
  LAYING_TYPE: 'Laying type',
  SURFACE_TYPE: 'Surface type',
  WIDTH: 'Width',
  DEPTH: 'Depth',
  POINT_OBJECT: 'Point object',
  MARKER_SPHERE: 'Marker sphere',
  HOUSE_LEAD_VARIANT: 'House lead variant',
  PARENT_NETWORK_NODE: 'Parent network node',
};

export const orderedProblemTitles: ReworkCategory[] = [
  'ADDRESS',
  'CONNECTOR_OR_PIPE_FITTING',
  'DOUBLE_CHECK_PHOTOS',
  'ELEMENT_NAME',
  'HOUSE_LEAD_VARIANT',
  'MARKER_SPHERE',
  'MISSING_ELEMENT',
  'PARENT_NETWORK_NODE',
  'PIPE_COLOUR',
  'PIPE_STRENGTH',
  'PROTECTIVE_PIPE',
  'POINT_OBJECT',
  'SCAN_POSITION',
  'TRENCH_OR_ELEMENT_PLACEMENT',
];

export const orderedAttributeTitles: ReworkCategory[] = [
  'LAYING_TYPE',
  'SURFACE_TYPE',
  'DEPTH',
  'WIDTH',
];
